<template>
<div id="qrcodeMirror" class="qrcodeMirror">
  <div id="header-navi" class="header-navi">
    <router-link :to="{ name: 'home'}" class="header-navi__back">Back</router-link>
    <h2 class="header-navi__ttl">カスタム商品連携</h2>
  </div>
  <div class="qrcodeMirror__wrap">
    <div class="qrcodeMirror__wrap__card">
      <header class="qrcodeMirror__wrap__card__header">カスタム商品連携</header>
      <div class="qrcodeMirror__wrap__card__content">
        <p class="qrcodeMirror__wrap__card__content__lead">お手持ちのデバイスで発行されたワンタイムパスワードを入力してください。データを読み取ってお手持ちのカスタム商品をスマートミラーで編集できます。</p>

        <section class="qrcodeMirror__wrap__card__content__oneTimePassword">
          <!-- <label for="oneTimePassword">ワンタイムパスワードで連携</label> -->
          <input
            name="oneTimePassword"
            class="qrcodeMirror__wrap__card__content__input"
            type="number"
            v-model="inputOneTimePassword"
            @input="checkOneTimePassword"
            placeholder="4桁の数字を入力" />
        </section>
        <!-- <section class="qrcodeMirror__wrap__card__content__customID">
          <label for="customID">カスタムIDで連携</label>
          <input
            name="customID"
            class="qrcodeMirror__wrap__card__content__input"
            type="text"
            v-model="inputCustomID"
            placeholder="12桁のカスタムIDを入力" />
          <button class="qrcodeMirror__wrap__card__content__button" @click="checkCustomID">カスタムIDから検索</button>
        </section> -->
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    @close="showModal = false"
    :content="readURL"
    is-navi="true"
    :modalObject="modalObject"
    :href="this.readURL" />
  <div @click="isMirrorMenuModal = true" class="mirrorGlobalMenu">
    <img src="@/assets/images/mirror/commons/commons-menu.svg" alt="Menu">
  </div>
  <MirrorMenuModal
    v-if="isMirrorMenuModal"
    @closeMenu="isMirrorMenuModal = false" />
  <ScreenSaverModal
    v-if="isScreenSaver"
    @closeScreenSaver="isScreenSaver = false" />
  <Loading
    v-if="isLoading" />
</div>
</template>

<script>
/* eslint-disable */

import Modal from '@/components/Modal'
import MirrorMenuModal from '@/components/mirror/MirrorMenuModal'
import ScreenSaverModal from '@/components/mirror/ScreenSaverModal'
import ScreenSaver from '@/assets/class/ScreenSaver'
import customMgr from '@/modules/CustomManager.js'

export default {
  mixins: [ScreenSaver],
  components: {
    Modal,
    MirrorMenuModal,
    ScreenSaverModal
  },
  beforeRouteEnter (to, from, next) {
    next()
  },
  data () {
    return {
      isLoading: false,
      showModal: false,
      // inputCustomID: '',
      inputOneTimePassword: '',
      readURL: '',
      video: '',
      stream: null,
      enterFrame: null,
      modalObject: {
        title: 'カスタム画面に移動', content: '', routerLink: { name: 'mirror-custom', query: { customid: '' }}, href: '', showNo: true, showOk: false
      },
      isMirrorMenuModal: false
    }
  },
  metaInfo: {
    meta: [
      { name: 'viewport', content: 'width=1080,user-scalable=no' }
    ]
  },
  watch: {
    showModal: {
      handler () {
      }
    }
  },
  methods: {
    checkOneTimePassword () {
      if(this.inputOneTimePassword.length > 3) {
        this.isLoading = true

        customMgr.getOneTimePasswordData().then((allData) => {
          let isMatch = false
          let customID = ''

          for (const key in allData) {
            if (allData.hasOwnProperty(key)) {
              const element = allData[key]

              if(element['password'] === this.inputOneTimePassword) {
                isMatch = true
                customID = element['customID']
                break
              }
            }
          }

          if (isMatch) {
            this.$router.push({ name: 'mirror-custom', query: { customid: customID }})
          } else {
            this.inputOneTimePassword = ''
            this.showModal = true
            this.modalObject = {
              title: 'パスワードが一致しません',
              content: 'データが存在しない、またはワンタイムパスワードが期限切れです。',
              routerLink: '',
              href: '',
              showNo: false,
              showOk: true
            }
          }
          this.isLoading = false
        })
      }
    },
    // checkCustomID () {
    //   customMgr.getCustomItem(this.inputCustomID).then((result) => {
    //     this.$router.push({ name: 'mirror-custom', query: { customid: this.inputCustomID }})
    //   }).catch(() => {
    //     this.showModal = true
    //     this.modalObject = {
    //     title: 'カスタムIDが一致しません',
    //     content: 'データが存在しない、またはIDが間違っています',
    //     routerLink: '',
    //     href: '',
    //     showNo: false,
    //     showOk: true
    //     }
    //   })
    // }
  }
}

</script>

<style lang="scss" scoped>
.header-navi {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
.qrcodeMirror {
  position: fixed;
  width: 100%;
  height: 100%;
  background: $black;

  &__wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    &__card {
      background: $base-white;
      width: 55vw;
      padding: 40px 45px;
      display: block;
      position: absolute;

      &__header {
        padding: 20px;
        font-size: 4vw;
        font-weight: bold;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;

        @include mq-up() {
          font-size: 3vw;
          padding: 2vh 3vw 1vh;
        }

        &__icn {
          width: 4.5vw;
          margin-right: 2vw;
        }
      }

      &__content {
        &__lead {
          font-size: 18px;
          margin-bottom: 30px;
          line-height: 1.6;
        }

        &__input {
          width: 100%;
          height: 50px;
          padding: 40px 10px;
          font-size: 36px;
          font-weight: bold;
          text-align: center;
          background: $right-gray;
          border: none;
          margin-bottom: 20px;

          &::placeholder {
            color: $gray;
          }
        }

        $this: &;

        section {
          // margin-bottom: 40px;
          // &#{$this}__oneTimePassword {
          //   border-bottom: 2px solid $right-gray;
          //   padding-bottom: 10px;
          // }

          label {
            display: block;
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 20px;
          }
        }

        &__button {
          border: none;
          outline: none;
          width: 100%;
          font-size: 20px;
          color: $base-white;
          padding: 20px 10px;
          background: #111;
        }
      }
    }
  }
  .mirrorGlobalMenu {
    @include mirrorMenuBtn;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mirror/MirrorCustomID.vue